import { Text } from '@myinterview/component-library';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface IProps {
  currentQuestion: number;
  numberOfQuestions: number;
}

export const QuestionNumber:React.FC<IProps> = ({ currentQuestion, numberOfQuestions }) => {
  const { t } = useTranslation();
  return (
    <Text className="myinterview-widget__question-number myinterview-widget--rtl-support" size="S-Semibold">
      <span>
        {`${t('questionList.name')}`}
      </span>
      <span className="myinterview-widget__question-number-track">
        <span>{currentQuestion}</span>
        <span>/</span>
        <span>{numberOfQuestions}</span>
      </span>
    </Text>
  );
};
